export const checkoutSelector = store => store.checkout;
